<template>
  <ChartContainer
    :value="current"
    :type="type"
    :lastChart="lastChart"
    :nextChart="nextChart">
    <div
      class="loading-container"
      v-if="!current.isLoad">
      <van-loading
        type="spinner"
        size="20">
      </van-loading>
    </div>
    <div
      v-if="current.value && current.header && current.header.length"
      class="ry-dashboard__detailed-control">
      <div
        class="data-grid__body">

        <AllAvailable
          ref="AllAvailable"
          :header="current.header"
          headerColor="#e4ebf6"
          headerTitle="noteName"
          @sorting="tableSorting"
          @rowClick="rowClick"
          :tableData="current.value.dataList"
          :has-index="!!current.chartPropertiesHolder.showIndex"
          :lock-amount="current.chartPropertiesHolder.freezeEnable? current.chartPropertiesHolder.freezeColumn: 0"
          :formId="current.dataSourceId">
        </AllAvailable>
      </div>
      <footer class="data-grid__footer">
        <div class="data-grid__footer-page-size">
          每页
          <ry-select
            :dataSource="[10,20,30,40,50]"
            :value.sync="current.value.pageSize"
            @change="pageSizeChange"
            :isObject="false">
          </ry-select>
          条
        </div>

        <el-pagination
          :current-page.sync="current.value.currentPage"
          :page-count="current.value.totalPage"
          @current-change="currentPageChange"
          layout="prev, pager, next">
        </el-pagination>
      </footer>
      <FormDataDetail
        v-if="false"
        ref="formDataDetail"
        :formId="current.dataSourceId">
      </FormDataDetail>
    </div>
  </ChartContainer>
</template>

<script>
  import ChartContainer from './common/container'
  import AllAvailable from "../../component/AllAvailable"
  import FormDataDetail from "../../component/FormDataDetail"
  import {SOURCE_TYPE__AGGREGATION_TABLE} from "../types";
  import RySelect from "../../component/RySelect";

  export default {
    props: {
      value: Object,
      type: Number,
      nextChart: Function,
      lastChart: Function
    },
    components: {
      ChartContainer,
      AllAvailable,
      FormDataDetail,
      RySelect
    },
    data() {
      return {
        current: this.value
      }
    },
    created() {

    },
    methods: {
      tableSorting(sort) {
        this.current.value.sort = sort
        this.current.value.currentPage = 1
        this.current.getValue()
      },
      // 表格点击
      rowClick(row) {
        if (this.current.dataSourceType === SOURCE_TYPE__AGGREGATION_TABLE) {
          return
        }
        let index = 0
        for (let i = 0; i < this.current.value.dataList.length; i++) {
          if (this.current.value.dataList[i].instanceId === row.instanceId) {
            index = i
            break
          }
        }
        let fields = this.current.chartPropertiesHolder.showFields.map(field => field.dataId)
        // if (this.$refs.formDataDetail) {
        //   this.$refs.formDataDetail.open(row.instanceId, fields)
        // }


        const toast = this.$toast.loading({
          message: '加载中...'
        })

        this.$store.dispatch('reqNodeSave', {
          company: this.$store.getters.currentCompany,
          companyId: this.$store.getters.currentCompanyId,
          userId: this.$store.getters.userId,
          instanceId: row.instanceId,
          showFields: fields,
          appId: this.$store.getters.currentAppId,
          formId: this.current.dataSourceId,
          dataList: [],
          token: this.$store.getters.token,
          hiddenEdit: 1,
          env: 'dash'
        }).then(res => {
          return this.$store.dispatch('reqNodeSave', {
            company: this.$store.getters.currentCompany,
            companyId: this.$store.getters.currentCompanyId,
            userId: this.$store.getters.userId,
            appId: this.$store.getters.currentAppId,
            formId: this.current.dataSourceId,
            token: this.$store.getters.token,
            env: 'dash',
            to: `${location.origin}${this.$MINIAPP_BASE_PATH}/#/formDataDetail?key=${res.nodeKey}`
          })
        }).then(res => {
          const aEle = document.createElement('a')
          if (aEle) {
            aEle.href = `${location.origin}${this.$MINIAPP_BASE_PATH}/#/3rd_router?key=${res.nodeKey}`
            aEle.target = '_self'
            aEle.click()
          }
        }).catch(err => {
          console.error(err)
        })
          .finally(() => {
            toast.clear()
          })
      },
      pageSizeChange() {
        this.current.getValue()
      },
      currentPageChange() {
        this.current.getValue()
      }
    }
  }
</script>


<style lang="less">
  .ry-dashboard__detailed-control {
    width: 100%;
    height: 100%;
    position: relative;

    > .data-grid__body {
      position: absolute;
      top: 0;
      bottom: 45px;
      padding: 0 12px;
      left: 0;
      right: 0;
      overflow: auto;
      -webkit-overflow-scrolling: touch;

      > .el-table {
        height: 100%;
        width: fit-content;
        max-width: none;

        .el-table__header-wrapper {
          width: fit-content;
        }

        .el-table__body-wrapper {
          width: fit-content;
        }
      }

      .empty-background__container {
        background-size: contain;
      }
    }

    > .data-grid__footer {
      width: 100%;
      border-top: 1px solid #e6e6e6;
      position: absolute;
      height: 45px;
      bottom: 0;
      padding: 6px 0;
      display: flex;
      justify-content: space-between;

      .data-grid__footer-page-size {
        float: left;
        font-size: 14px;
        color: #909399;
        height: 32px;
        padding: 0 12px;
        line-height: 32px;
        display: flex;
        width: 116px;

        > .el-select {
          width: 70px;
          height: 32px;
        }
      }

      .el-pagination {
        float: right;
        flex: 1;
        text-align: end;
        overflow: auto;
      }
    }
  }
</style>
